export default __webpack_public_path__ + "static/media/flatbread.69d46e86.webp";